/* ============================================
   Weekend Solar - Shopify Theme JavaScript
   ============================================ */

(function() {
  'use strict';

  // ==========================================
  // Mobile Navigation
  // ==========================================
  var mobileMenuBtn = document.getElementById('wsMobileMenuBtn');
  var mobileDrawer = document.getElementById('wsMobileDrawer');
  var mobileOverlay = document.getElementById('wsMobileOverlay');
  var mobileCloseBtn = document.getElementById('wsMobileCloseBtn');

  function openMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileMenu);
  if (mobileCloseBtn) mobileCloseBtn.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // ==========================================
  // Smooth Scroll for Anchor Links
  // ==========================================
  document.querySelectorAll('.js-scroll-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        e.preventDefault();
        var target = document.querySelector(href);
        if (target) {
          closeMobileMenu();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  // ==========================================
  // Header Scroll Effect
  // ==========================================
  var header = document.getElementById('wsHeader');
  var headerThreshold = window.innerHeight * 0.8;

  function onHeaderScroll() {
    if (window.scrollY > headerThreshold) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  if (header) {
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // ==========================================
  // Scroll Reveal (fade-in on scroll)
  // ==========================================
  var revealElements = document.querySelectorAll('.ws-reveal');

  if (revealElements.length > 0 && typeof gsap !== 'undefined') {
    revealElements.forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, y: 40 },
        {
          opacity: 1, y: 0, duration: 0.8, ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none none'
          }
        }
      );
    });
  } else if (revealElements.length > 0) {
    // Fallback without GSAP
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    revealElements.forEach(function(el) {
      revealObserver.observe(el);
    });
  }

  // ==========================================
  // Marquee Wipe Section (GSAP)
  // ==========================================
  var wipeWrapper = document.querySelector('.wipe-wrapper');
  if (wipeWrapper && typeof gsap !== 'undefined') {
    var wipeTl = gsap.timeline({
      scrollTrigger: {
        trigger: wipeWrapper,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1
      }
    });
    wipeTl.fromTo('.wipe-scroll-text', { y: '100vh' }, { y: '-100%', ease: 'none' });
    wipeTl.fromTo('.wipe-bg-text', { x: '20vw' }, { x: '-20vw', ease: 'none' }, 0);
  }

  // ==========================================
  // Sticky Mobile CTA Bar (show only on mobile)
  // ==========================================
  var stickyCta = document.querySelector('.ws-sticky-cta');
  if (stickyCta && window.innerWidth < 640) {
    var ctaShown = false;
    window.addEventListener('scroll', function() {
      if (window.scrollY > window.innerHeight && !ctaShown) {
        stickyCta.style.display = 'flex';
        ctaShown = true;
      }
    }, { passive: true });
  }

  // ==========================================
  // Contact Form Success Handler
  // ==========================================
  var contactForm = document.getElementById('wsContactForm');
  var contactSuccess = document.getElementById('contactSuccess');

  if (contactForm) {
    // Check for Shopify form success
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('contact_posted') === 'true') {
      contactForm.style.display = 'none';
      if (contactSuccess) contactSuccess.classList.add('show');
    }

    contactForm.addEventListener('submit', function(e) {
      // Let Shopify handle the form submission
      // This just adds a fallback success message
    });
  }

  // ==========================================
  // File Upload Label Update
  // ==========================================
  var fileInputs = document.querySelectorAll('input[type="file"]');
  fileInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      var label = this.closest('label');
      if (label && this.files && this.files[0]) {
        var textSpan = label.querySelector('span');
        if (textSpan) textSpan.textContent = this.files[0].name;
      }
    });
  });

})();
